var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ReportRepair" },
    [
      _c(
        "van-cell-group",
        { staticClass: "addressBox" },
        [
          _c("van-cell", {
            staticClass: "addressBtn",
            attrs: { title: "地址", "is-link": "", value: "点击选择地址" },
            on: {
              click: function($event) {
                return _vm.gotoPath("/addressmanage")
              }
            }
          }),
          _vm._v(" "),
          _c("van-cell", {
            staticClass: "address",
            attrs: { value: _vm.saveData.address }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            staticClass: "Repairphone",
            attrs: { title: "电话报修", value: _vm.Repairphone },
            on: { click: _vm.callPhone }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "cardIcon" },
        [
          _c("van-field", {
            attrs: {
              required: "",
              clearable: "",
              label: "姓名",
              placeholder: "请输入姓名"
            },
            model: {
              value: _vm.saveData.name,
              callback: function($$v) {
                _vm.$set(_vm.saveData, "name", $$v)
              },
              expression: "saveData.name"
            }
          }),
          _vm._v(" "),
          _c("van-field", {
            staticClass: "phone",
            attrs: {
              required: "",
              clearable: "",
              label: "电话",
              placeholder: "请输入联系电话"
            },
            on: {
              blur: function($event) {
                return _vm.Cardtest("phone")
              }
            },
            model: {
              value: _vm.saveData.phone,
              callback: function($$v) {
                _vm.$set(_vm.saveData, "phone", $$v)
              },
              expression: "saveData.phone"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "quick" },
        [
          _c(
            "van-tabs",
            {
              on: { click: _vm.onClick },
              model: {
                value: _vm.activeName,
                callback: function($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName"
              }
            },
            _vm._l(_vm.RepairType, function(item, index) {
              return _c(
                "van-tab",
                {
                  key: item.repairType.id,
                  attrs: { title: item.repairType.id, name: item.repairType.id }
                },
                [
                  _c(
                    "div",
                    {
                      attrs: { slot: "title" },
                      on: {
                        click: function($event) {
                          return _vm.getTypeId(item.repairType.id)
                        }
                      },
                      slot: "title"
                    },
                    [_vm._v(_vm._s(item.repairType.name))]
                  ),
                  _vm._v(" "),
                  _vm._l(item.repairFaqList, function(items, index) {
                    return _c("van-cell", {
                      key: items.id,
                      staticClass: "repairFaq",
                      attrs: { value: items.question },
                      on: {
                        click: function($event) {
                          return _vm.ckeckRepairFaq(
                            $event,
                            items.id,
                            items.question
                          )
                        }
                      }
                    })
                  })
                ],
                2
              )
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("van-cell-group", { staticClass: "reason" }, [
        _c("div", { staticClass: "reasonBox" }, [
          _c("label", [_vm._v("报修描述")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "reasonBox" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.saveData.reason,
                expression: "saveData.reason"
              }
            ],
            attrs: {
              name: "reason",
              placeholder: "请点击选择快捷语或输入描述",
              cols: "30",
              rows: "8"
            },
            domProps: { value: _vm.saveData.reason },
            on: {
              blur: _vm.Cardtest,
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.saveData, "reason", $event.target.value)
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "ImgBar" },
          [
            _vm._l(_vm.fileList, function(item, index) {
              return _c(
                "span",
                { key: index, staticClass: "ImgBox" },
                [
                  _c("img", {
                    staticClass: "uploadimg",
                    attrs: { src: item, alt: "图片" },
                    on: { click: _vm.ImagePreviewShow }
                  }),
                  _vm._v(" "),
                  _c("van-icon", {
                    staticClass: "delte",
                    attrs: { name: "delete" },
                    on: {
                      click: function($event) {
                        return _vm.delImg(index)
                      }
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("van-uploader", {
              staticClass: "imgList",
              attrs: {
                "after-read": _vm.onRead,
                accept: "image/*",
                multiple: "",
                "max-count": 5,
                "upload-text": "最多可上传5张"
              }
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "van-cell-group",
        [
          _c("van-cell", {
            attrs: {
              title: "紧急程度",
              "is-link": "",
              value: _vm.urgencyStatusData.codeLabel
            },
            on: { click: _vm.onUrgencyStatus }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-col",
        {
          staticClass: "barBtn",
          attrs: { span: "24", type: "flex", justify: "space-between" }
        },
        [
          _c(
            "van-button",
            {
              staticClass: "saveBth",
              attrs: { round: "", type: "danger", size: "large" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.UpdateInfo($event)
                }
              }
            },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          staticClass: "callPhonePop",
          model: {
            value: _vm.iscallPhoneShow,
            callback: function($$v) {
              _vm.iscallPhoneShow = $$v
            },
            expression: "iscallPhoneShow"
          }
        },
        [
          _c("div", { staticClass: "phoneText" }, [
            _c("span", [_vm._v("拨打")]),
            _vm._v(_vm._s(this.Repairphone))
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              { staticClass: "bth cancel", attrs: { href: "javaScript:;" } },
              [_vm._v("取消")]
            ),
            _c(
              "a",
              {
                staticClass: "bth confirm",
                attrs: { href: "tel:" + _vm.Repairphone }
              },
              [_vm._v("确定")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShow,
            callback: function($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow"
          }
        },
        [
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isRepair,
                expression: "isRepair"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.columns,
              "value-key": "companyName"
            },
            on: {
              confirm: _vm.onRepairConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          }),
          _vm._v(" "),
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isUrgencyStatus,
                expression: "isUrgencyStatus"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.urgencyStatusColumns,
              "value-key": "codeLabel"
            },
            on: {
              confirm: _vm.onUrgencyStatusConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          }),
          _vm._v(" "),
          _c("van-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isHandleExpireUnit,
                expression: "isHandleExpireUnit"
              }
            ],
            attrs: {
              "show-toolbar": "",
              columns: _vm.handleExpireUnitColumns,
              "value-key": "codeLabel"
            },
            on: {
              confirm: _vm.onHandleExpireUnitConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            }
          }),
          _vm._v(" "),
          _c("van-datetime-picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isReservationTime,
                expression: "isReservationTime"
              }
            ],
            attrs: {
              type: "datetime",
              title: "选择预约时间",
              "min-date": _vm.minDate
            },
            on: {
              confirm: _vm.onReservationTimeConfirm,
              cancel: function($event) {
                _vm.isShow = false
              }
            },
            model: {
              value: _vm.reservationTimeDate,
              callback: function($$v) {
                _vm.reservationTimeDate = $$v
              },
              expression: "reservationTimeDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-260affea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260affea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/heatReportRepair/ReportRepair.vue
// module id = null
// module chunks = 